(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["authentication-process"] && !Shopify.designMode) return;
  try {
    
  if (!window.authProcessDialogsBound) {
    window.authProcessDialogsBound = true;

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-auth-process-open]');
      if (opener) {
        var dialog = document.getElementById(opener.getAttribute('data-auth-process-open'));
        if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
        return;
      }

      var closer = event.target.closest('[data-auth-process-close]');
      if (closer) {
        closer.closest('dialog').close();
        return;
      }

      // Clicking the backdrop targets the dialog element itself
      if (event.target.classList && event.target.classList.contains('auth-process__dialog')) {
        event.target.close();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
